import axios from 'axios'
import qs from 'qs'
import errorHandler from './error-handler'

export default {
  async get () {
    return axios.get('/api/jobseekers').then(r => r.data).catch(errorHandler)
  },
  async update (data) {
    return axios.put('/api/jobseekers', data).then(r => r.data)
      .catch(errorHandler)
  },
  async updateVisibility (data) {
    return axios.put('/api/jobseekers/visibility', data).then(r => r.data)
      .catch(errorHandler)
  },
  async uploadResume (file) {
    const formData = new FormData()
    formData.append('file', file)
    return axios.post('/api/jobseekers/resume', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(r => r.data).catch(errorHandler)
  },
  async uploadMundoCrypto (file) {
    const formData = new FormData()
    formData.append('file', file)
    return axios.post('/api/jobseekers/mundoCryptoCer', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(r => r.data).catch(errorHandler)
  },
  async uploadResumeByAdmin (file, userId) {
    const formData = new FormData()
    formData.append('file', file)
    return axios.post(`/api/jobseekers/${userId}/resume`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(r => r.data).catch(errorHandler)
  },
  async list (query) {
    return axios.get(`/api/jobseekers/list?${qs.stringify(query)}`)
      .then(r => r.data).catch(errorHandler)
  },
  async search (query) {
    return axios.get(`/api/jobseekers/search?${qs.stringify(query)}`)
      .then(r => r.data).catch(errorHandler)
  },
  async getById (id) {
    return axios.get(`/api/jobseekers/${id}`).then(r => r.data)
      .catch(errorHandler)
  },
  async getJobseekerExperience (id) {
    return axios.get(`/api/jobseekers/${id}/experiences`).then(r => r.data)
      .catch(errorHandler)
  },
  async lookup (text) {
    const query = { text }
    return axios.get(`/api/jobseekers/lookup?${qs.stringify(query)}`)
      .then(r => r.data).catch(errorHandler)
  },
  async getJobSeekersBoard () {
    return axios.get(`/api/jobseekers/boards`)
      .then(r => r.data).catch(errorHandler)
  },
  async getFilterJobSeekers ({boards = [], contractTypes = [], keyword = '', location = ''}) {
    return axios.post('/api/jobseekers/filter', {boards, contractTypes, keyword, location}).then(r => r.data).catch(errorHandler)
  },
  async deleteResume () {
    return axios.delete(`/api/jobseekers/resume`).then(r => r).catch(errorHandler)
  },
  async getTalentId (id) {
    return axios.get(`/api/jobseekers/${id}`)
      .then(r => r.data).catch(errorHandler)
  }
}



// WEBPACK FOOTER //
// ./src/api/jobseekers.js